module.exports = __webpack_public_path__ + "static/frontUserNew/img/inner-list02.317321a6.png";